import Footer from '../../components/Footer'
import RegisterForm from './RegisterForm'

function Login() {
  return (
    <div className='login-page'>
      <RegisterForm/>
      <Footer/>
    </div>
  )
}

export default Login